export default __webpack_public_path__ + "static/hero.light-52f3c7b95fd24861927ac34d39f52f0e.png";